<form class="itinerary-model-content-inner" [formGroup]="notesForm" (ngSubmit)="onSubmit()">
  <div class="itinerary-model-content">
    <div class="ion-no-padding mb-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Notes <span class="text-danger warning-message" *ngIf="notesForm.get('notes')?.invalid && notesForm.get('notes')?.touched">Required / Invalid</span></ion-title>
    </div> 
  
    <div class="form-container ion-padding-horizontal">
      <div class="row">
        <div class="col">
          <div class="input-container">
            <app-text-formatting-input formControlName="notes" [inputHeight]="'lg'"></app-text-formatting-input>
          </div>
        </div>
      </div>
    </div>
    <div class="dashed-line"></div>
  </div>

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>
